import React, { useRef,useEffect,useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function CertificateView({ open, handleClose, logDetails }) {
  const pdfRef = useRef();
//console.log(logDetails?.raw.size)
  // Fallback data in case logDetails is incomplete
  const certificateData = {
    certificate_number: logDetails?.operationId || "N/A",
    date: logDetails?.raw?.time
      ? new Date(logDetails.raw.time).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
      : "N/A",
    time: logDetails?.time || "N/A",
    erasing_physical_drive: {
      drive: logDetails?.json
        ? JSON.parse(logDetails.json)?.path || logDetails.deviceName || "Unknown Drive"
        : "Unknown Drive",
      attributes: {
        erase_method: "Secure Erase", // Placeholder, adjust based on your data
        verification: "100% Verified", // Placeholder
        process_integrity: "Successful", // Placeholder
        use_fingerprint: "No", // Placeholder
        initialize_fixed_disks: "Yes", // Placeholder
        initialize_removable_disks: "No", // Placeholder
      },
    },
    disk_information: {
      product_name: logDetails?.deviceName || "Unknown Device",
      serial_number: "N/A", // Add if available in logDetails
      disk_signature: "N/A", // Add if available
      partitioning: "GPT", // Placeholder
      disk_size: logDetails?.raw.size||0, // Add if available
      total_sectors: "N/A", // Add if available
      bytes_per_sector: "512", // Placeholder
    },
    results: {
      erase_scope: logDetails?.activity, // Placeholder
      name: logDetails?.activity || "N/A",
      started_on: logDetails?.raw?.time
        ? new Date(logDetails.raw.time).toLocaleString("en-US")
        : "N/A",
      errors: "None", // Placeholder
      status: logDetails?.status || "Completed",
      erase_pass: "Pass 1: Completed", // Placeholder
      verification: "Pass 1: Verified", // Placeholder
    },
    system_information: {
      os_version: logDetails?.raw.OS||"N/A", // Add if available
      type: "N/A", // Add if available
      kernel: "N/A", // Add if available
    },
   
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);

      let imgWidth = pdfWidth;
      let imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (imgHeight > pdfHeight) {
        imgHeight = pdfHeight;
        imgWidth = (imgProps.width * pdfHeight) / imgProps.height;
      }

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`certificate_${certificateData.certificate_number}.pdf`);
    });
  };

  const sectionStyle = {
    marginTop: "20px",
  };

  const labelCell = {
    fontWeight: "bold",
    paddingRight: "10px",
    whiteSpace: "nowrap",
  };
  const valueCell = {
    color: "#000",
    paddingLeft: "5px",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#F7F7F7",
          padding: "20px 30px",
          borderRadius: "8px",
          width: "90vw",
          maxWidth: "794px", // A4 width in pixels at 96 DPI
          maxHeight: "70vh", // A4 height in pixels at 96 DPI
          position: "relative",
          boxShadow: "6px 6px 6px #00000040",
          overflow: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography
            sx={{
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "24px",
              fontWeight: 700,
              color: "#202224",
            }}
          >
            Erase Certificate
          </Typography>
          <FontAwesomeIcon
            icon={faTimes}
            style={{
              height: "17px",
              width: "17px",
              color: "#FF7A00",
              cursor: "pointer",
            }}
            onClick={handleClose}
          />
        </Box>

        <Box
          ref={pdfRef}
          sx={{
            border: "1px solid #ddd",
            padding: "20px 30px",
            backgroundColor: "white",
            width: "100%",
            height: "auto",
            fontFamily: "Arial, sans-serif",
            boxSizing: "border-box",
            fontSize: "12px",
            lineHeight: "1.4",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: "#8b96d2",
              padding: "8px 15px",
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
           Antima
          </Box>

          {/* Certificate Info */}
          <Typography sx={{ color: "#000088", fontSize: "25px", marginTop: "20px" }}>
            ERASE CERTIFICATE
          </Typography>
          <table>
            <tbody>
              <tr>
                <td style={labelCell}>Operation ID:</td>
                <td style={valueCell}>{certificateData.certificate_number}</td>
              </tr>
              <tr>
                <td style={labelCell}>Date:</td>
                <td style={valueCell}>{certificateData.date}</td>
              </tr>
              <tr>
                <td style={labelCell}>Time:</td>
                <td style={valueCell}>{certificateData.time}</td>
              </tr>
              <tr>
                <td style={labelCell}>User:</td>
                <td style={valueCell}>{logDetails?.user || "N/A"}</td>
              </tr>
              <tr>
                <td style={labelCell}>Department:</td>
                <td style={valueCell}>{logDetails?.department || "N/A"}</td>
              </tr>
            </tbody>
          </table>

          {/* Two column layout */}
          <Box sx={{ display: "flex", marginTop: "20px" }}>
            {/* Left column */}
            <Box sx={{ flex: 1, paddingRight: "20px" }}>
              {/* Attributes */}
              <Box sx={sectionStyle}>
                <Typography component="h3">
                  Erasing {certificateData.erasing_physical_drive.drive}
                </Typography>
                <table>
                  <tbody>
                    <tr>
                      <td style={labelCell}>Erase Method:</td>
                     
                    </tr>
                    <tr>
                      <td style={labelCell}>Verification:</td>
                      <td style={valueCell}>
                        {certificateData.erasing_physical_drive.attributes.verification}
                      </td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Process Integrity:</td>
                      <td style={{ ...valueCell, color: "green" }}>
                        {certificateData.erasing_physical_drive.attributes.process_integrity}
                      </td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Use Fingerprint:</td>
                      <td style={valueCell}>
                        {certificateData.erasing_physical_drive.attributes.use_fingerprint}
                      </td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Initialize Fixed Disks:</td>
                      <td style={valueCell}>
                        {certificateData.erasing_physical_drive.attributes.initialize_fixed_disks}
                      </td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Initialize Removable Disks:</td>
                      <td style={valueCell}>
                        {certificateData.erasing_physical_drive.attributes.initialize_removable_disks}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>

              {/* Disk Information */}
              <Box sx={sectionStyle}>
                <Typography component="h3">Disk Information</Typography>
                <table>
                  <tbody>
                    <tr>
                      <td style={labelCell}>Name:</td>
                      <td style={valueCell}>{certificateData.erasing_physical_drive.drive}</td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Product Name:</td>
                      <td style={valueCell}>{certificateData.disk_information.product_name}</td>
                    </tr>
                    
                    <tr>
                      <td style={labelCell}>Size:</td>
                      <td style={valueCell}>{certificateData.disk_information.disk_size}</td>
                    </tr>
                    
                    
                  </tbody>
                </table>
              </Box>

              {/* Results */}
              <Box sx={sectionStyle}>
                <Typography component="h3">Results</Typography>
                <table>
                  <tbody>
                    <tr>
                      <td style={labelCell}>Erase Range:</td>
                      <td style={valueCell}>{certificateData.results.erase_scope}</td>
                    </tr>
                    
                    <tr>
                      <td style={labelCell}>Started at:</td>
                      <td style={valueCell}>{certificateData.results.started_on}</td>
                    </tr>
                    
                    <tr>
                      <td style={labelCell}>Errors:</td>
                      <td style={valueCell}>{certificateData.results.errors}</td>
                    </tr>
                    <tr>
                      <td style={labelCell}>Result:</td>
                      <td style={{ ...valueCell, color: "green" }}>{certificateData.results.status}</td>
                    </tr>
                  </tbody>
                </table>
              </Box>

              {/* System Info */}
              <Box sx={sectionStyle}>
                <Typography component="h3">System Information</Typography>
                <table>
                  <tbody>
                    <tr>
                      <td style={labelCell}>OS:</td>
                      <td style={valueCell}>{certificateData.system_information.os_version}</td>
                    </tr>
                    
                  </tbody>
                </table>
              </Box>
            </Box>


          </Box>

          {/* Footer */}
          <Box sx={{ marginTop: "100px", textAlign: "center", color: "#818181ff" }}>
            <hr />
            <Typography sx={{ fontWeight: "bold" }}>
              Erased by Antima
            </Typography>
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            onClick={downloadPDF}
            sx={{
              backgroundColor: "#FF7A00",
              borderRadius: "5px",
              textTransform: "none",
              fontSize: "14px",
              padding: "2px 16px",
              fontFamily: "Nunito Sans, sans-serif",
              "&:hover": {
                backgroundColor: "#FF6B00",
              },
            }}
          >
            Download as PDF
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default CertificateView;